import React from 'react';

import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TCardCollection = {
  kind?: 'grid';
  className?: string;
  children?: React.ReactNode;
};

const CardCollection = ({ kind, ...rest }: TCardCollection) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
  });
  return <Box {...rest} {...conditionalProps} as="section" name="CardCollection" />;
};

export default CardCollection;
